import { render, staticRenderFns } from "./LegacyGeneralPlan.vue?vue&type=template&id=7031b512&scoped=true"
import script from "./LegacyGeneralPlan.vue?vue&type=script&lang=js"
export * from "./LegacyGeneralPlan.vue?vue&type=script&lang=js"
import style0 from "./LegacyGeneralPlan.vue?vue&type=style&index=0&id=7031b512&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7031b512",
  null
  
)

export default component.exports